module.exports = __webpack_public_path__ + "img/upcoins.4fdaa63a.svg";